import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {scraperRegister} from "../../services/scraperRegister";
import {langRegister} from "../../services/langRegister";

class DropdownRegionNarrow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: this.props.error,
            placeholder: this.props.placeholder,
            value: this.props.value,
            places: this.props.places?this.props.places:[],
            region_grid: this.props.grid?this.props.grid:{},
            regions: [],
            errors: {},
            inhouse: false
        };
    };

    componentWillMount() {

    };

    componentDidMount() {
        this.setState({
            inhouse: this.props.inhouse
        });
        this.init.regions();
    }

    _renderText(item) {
        return langRegister.get("dropdown-region", item, this.state.temp_lang);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            error: nextProps.error,
            placeholder: nextProps.placeholder,
            places: nextProps.places,
            region_grid: nextProps.grid,
            value: nextProps.value,
            inhouse: nextProps.inhouse,
            errors: nextProps.errors
        });
    }

    init = {
        regions: () => {
            dataRegister.getRegions(salesChannelRegister.get("market")).then((response) => {
                if (response.regions) {
                    this.setState({
                        regions: response.regions,
                    }, () => {
                        if(Object.keys(this.state.region_grid).length < 1) {
                            this.init.grid(this.state.regions, 1);
                        }else{
                            let highest_key = 1;
                            for(let key in this.state.region_grid){
                                if(highest_key < key){
                                    highest_key = key;
                                }
                            }
                            this.init.grid(this.state.regions, highest_key);
                        }
                    });
                }
            }, (error) => {});
        },
        grid: (items, level) => {
            let contry_region = JSON.parse(salesChannelRegister.get("country_region"));
            if (Object.keys(this.state.region_grid).length < 1) {
                let contry_region_select = null;
                try {
                    if(this.state.places.length > 0){
                        let region = null;
                        let value = this.state.places[0];
                        let municipality_level = false;

                        if (salesChannelRegister.get('name') === 'boostabostad' && value.toLowerCase().indexOf("kommun") !== -1) {
                            municipality_level = 4;
                            for (let i = 0; i < items.length; i++) {
                                if(value.toLowerCase().indexOf(items[i].name.toLowerCase()) !== -1 && items[i].level === municipality_level){
                                    region = items[i];
                                }
                            }
                        } else {
                            for (let i = 0; i < items.length; i++) {
                                if(items[i].name.toLowerCase() === value.toLowerCase()){
                                    region = items[i];
                                }
                            }
                        }

                        if (region) {
                            this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                            let parent = region.parent_id;
                            let parent_parent = true;
                            if(region){
                                this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                for (let i = 0; i < items.length; i++) {
                                    if (region.level === 1){
                                        if (items[i].level === region.level) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                    } else {
                                        parent_parent = findParent(parent);
                                        if (parent_parent.parent_id) {
                                            if (items[i].level === region.level && items[i].country_code === region.country_code && items[i].parent_id === parent_parent.id) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        } else {
                                            if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        }
                                    }
                                }
                            }
                            if (parent) {
                                region = findParent(parent);
                                parent = region.parent_id;
                                let parent_parent = true;
                                if (region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (region.level === 1){
                                            if (items[i].level === region.level) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        } else {
                                            parent_parent = findParent(parent);
                                            if (parent_parent.parent_id) {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code && items[i].id === region.id) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            } else {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            }
                                        }
                                        /*
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                        */
                                    }
                                }
                            }
                            if (parent) {
                                region = findParent(parent);
                                parent = region.parent_id;
                                let parent_parent = true;
                                if (region){
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (region.level === 1){
                                            if (items[i].level === region.level) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        } else {
                                            parent_parent = findParent(parent);
                                            if (parent_parent.parent_id) {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code && items[i].id === region.id) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            } else {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            }
                                        }
                                        /*
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                        */
                                    }
                                }
                            }
                            if (parent) {
                                region = findParent(parent);
                                parent = region.parent_id;
                                let parent_parent = true;
                                if (region) {
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (region.level === 1){
                                            if (items[i].level === region.level) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        } else {
                                            parent_parent = findParent(parent);
                                            if (parent_parent.parent_id) {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code && items[i].id === region.id) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            } else {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            }
                                        }
                                        /*
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                        */
                                    }
                                }
                            }
                            if (parent) {
                                region = findParent(parent);
                                parent = region.parent_id;
                                let parent_parent = true;
                                if (region) {
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if(region.level === 1){
                                            if (items[i].level === region.level) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        } else {
                                            parent_parent = findParent(parent);
                                            if (parent_parent.parent_id) {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code && items[i].id === region.id) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            } else {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            }
                                        }
                                        /*
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                        */
                                    }
                                }
                            }
                            if (parent) {
                                region = findParent(parent);
                                parent = region.parent_id;
                                let parent_parent = true;
                                if (region) {
                                    this.state.region_grid[region.level] = {value: JSON.stringify(region), children: [], title: "Select Country", level: region.level};
                                    for (let i = 0; i < items.length; i++) {
                                        if (region.level === 1){
                                            if (items[i].level === region.level) {
                                                this.state.region_grid[region.level].children.push(items[i])
                                            }
                                        } else {
                                            parent_parent = findParent(parent);
                                            if (parent_parent.parent_id) {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code && items[i].id === region.id) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            } else {
                                                if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                                    this.state.region_grid[region.level].children.push(items[i])
                                                }
                                            }
                                        }
                                        /*
                                        if (items[i].level === region.level && items[i].country_code === region.country_code) {
                                            this.state.region_grid[region.level].children.push(items[i])
                                        }
                                        */
                                    }
                                }
                            }

                            let lowest = 1;
                            for (let key in this.state.region_grid){
                                if(lowest < key){
                                    lowest = key;
                                }
                            }

                            this.setState({
                                region_grid: this.state.region_grid
                            }, () => {
                                this.functions.setRegion(this.state.region_grid[lowest].value, lowest, true);
                                try {
                                    if (salesChannelRegister.get('name') === 'boostabostad') {
                                        if (municipality_level){
                                            this.functions.select(JSON.parse(this.state.region_grid[municipality_level].value), municipality_level, true);
                                        } else {
                                            this.functions.select(JSON.parse(this.state.region_grid[region.level].value), region.level, true);
                                        }
                                    }
                                }catch (e) {
                                    console.log(e);
                                }
                            });
                        }
                    }
                } catch (e) {}
                if (Object.keys(this.state.region_grid).length < 1) {
                    try {
                        this.state.region_grid[1] = {value: "-1", children: [], title: "Select Country", level: level};
                        for (let i = 0; i < items.length; i++) {
                            if (items[i].level === 1) {
                                console.log(items[i]);
                                this.state.region_grid[1].children.push(items[i])
                            }
                            if (contry_region.id === items[i].id) {
                                contry_region_select = items[i];
                            }
                        }
                    } catch (e) {
                    }
                    this.setState({
                        region_grid: this.state.region_grid
                    }, () => {
                        if (contry_region_select) {
                            this.functions.setRegion(JSON.stringify(contry_region_select), 1, true);
                        }
                        /*
                        try{
                            if(window.location.hostname.indexOf("localhost") !== -1 || window.location.hostname.indexOf("boostabostad") !== -1){
                                if(!this.state.value && this.state.region_grid){
                                    let highest_key = 0;
                                    for(let key in this.state.region_grid){
                                        if(this.state.region_grid[key] && this.state.region_grid[key].value){
                                            if(key > highest_key){
                                                highest_key = key;
                                            }
                                        }
                                    }
                                    if(highest_key !== 0){
                                        this.functions.select(JSON.parse(this.state.region_grid[highest_key].value));
                                    }
                                }
                            }
                        }catch (e) {
                            console.log(e);
                        }
                        */
                    });
                }
            }

            function findParent(item) {
                let value = null;
                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === item) {
                        value = items[i];
                        break;
                    }
                }
                return value;
            }

        },
    };

    functions = {
        select: (value, circle) => {
            //console.log(circle);
            this.props.onChange(value, this.state.region_grid, circle);
        },
        setRegion: (target, level_key, init) => {

            if (target !== "-1") {

                this.state.region_grid[JSON.parse(target).level].error = false;
                this.state.region_grid[JSON.parse(target).level].value = target;

                target = JSON.parse(target);

                //RESET ALL LEVELS BELOW SELECTED TARGET
                for (let key in this.state.region_grid) {
                    if (+this.state.region_grid[key].level > +target.level) {
                        delete this.state.region_grid[key];
                    }
                }

                let level_cap = 5;
                let level_skip = 1;

                if (salesChannelRegister.get('name') === 'boostabostad') {
                    level_cap = 7;
                    level_skip = 1;
                }

                let level = +target.level + level_skip;


                if (level < level_cap) {
                    if (init) {
                        try {
                            let scraper_data = JSON.parse(scraperRegister.get());
                            let search_query = scraper_data.additional_information.facts.places[1];
                            let match = false;
                            let current = false;
                            let parent = false;
                            if (search_query) {
                                if (salesChannelRegister.get('name') === 'boostabostad') {
                                    //ON BOOSTA BOSTAD WE MATCH AGAINST TWO LEVELS (DEFAULT PLUS EXTRA LEVEL)
                                    //CHECK IF MATCH NEXT LOWEST LEVEL
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            current = this.state.regions[i].id;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            current = this.state.regions[i].id;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        }
                                    }
                                    if (!match) {
                                        //IF NO MATCH NEXT LOWEST LEVEL CHECK MATCH LOWEST LEVEL
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level+1) {
                                                parent = this.state.regions[i].parent_id;
                                                console.log(this.state.regions[i].parent_id + " parent exit");
                                            } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level+1) {
                                                parent = this.state.regions[i].parent_id;
                                                console.log(this.state.regions[i].parent_id + " parent exit");
                                                console.log();
                                            }
                                        }
                                    }
                                    if (parent) {
                                        //IF MATCH LOWEST LEVEL SET NEXT LOWEST LEVEL
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].level === level && this.state.regions[i].id === parent) {
                                                match = true;
                                                current = this.state.regions[i].id;
                                                console.log(this.state.regions[i].parent_id + " select parent");
                                                this.state.region_grid[level] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level
                                                };
                                            } else if (this.state.regions[i].level === level && this.state.regions[i].id === parent) {
                                                match = true;
                                                current = this.state.regions[i].id;
                                                console.log(this.state.regions[i].parent_id + " select parent");
                                                this.state.region_grid[level] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level
                                                };
                                            }
                                        }
                                    }
                                    if (current) {
                                        //IF MATCH NEXT LOWEST LEVEL SET LOWEST LEVEL
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level+1 && this.state.regions[i].parent_id === current) {
                                                match = true;
                                                this.state.region_grid[level+1] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level+1
                                                };
                                            } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level+1 && this.state.regions[i].parent_id === current) {
                                                match = true;
                                                this.state.region_grid[level+1] = {
                                                    value: JSON.stringify(this.state.regions[i]),
                                                    children: [],
                                                    title: "Select",
                                                    level: level+1
                                                };
                                            }
                                        }
                                    }
                                } else {
                                    //ON PROPERTY BOOSTER WE MATCH AGAINST ONE LEVEL (DEFAULT LEVEL)
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].name.toLowerCase().indexOf(search_query.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        } else if (search_query.toLowerCase().indexOf(this.state.regions[i].name.toLowerCase()) !== -1 && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            match = true;
                                            this.state.region_grid[level] = {
                                                value: JSON.stringify(this.state.regions[i]),
                                                children: [],
                                                title: "Select",
                                                level: level
                                            };
                                        }
                                    }
                                }
                                if (match) {
                                    //SET DEFAULT LEVEL DATA
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].country_code === target.country_code && this.state.regions[i].level === level && this.state.regions[i].parent_id === target.id) {
                                            this.state.region_grid[level].children.push(this.state.regions[i])
                                        }
                                    }
                                    //SET EXTRA LEVEL DATA
                                    if (salesChannelRegister.get('name') === 'boostabostad') {
                                        for (let i = 0; i < this.state.regions.length; i++) {
                                            if (this.state.regions[i].country_code === target.country_code && this.state.regions[i].level === level+1 && this.state.regions[i].parent_id === current) {
                                                this.state.region_grid[level+1].children.push(this.state.regions[i])
                                            }
                                        }
                                    }
                                } else {
                                    this.state.region_grid[level] = {
                                        value: "-1",
                                        children: [],
                                        title: "Select",
                                        level: level
                                    };
                                    for (let i = 0; i < this.state.regions.length; i++) {
                                        if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                            this.state.region_grid[level].children.push(this.state.regions[i])
                                        }
                                    }
                                    if (this.state.region_grid[level].children.length < 1) {
                                        delete this.state.region_grid[level];
                                    }
                                }
                            } else {
                                this.state.region_grid[level] = {
                                    value: "-1",
                                    children: [],
                                    title: "Select",
                                    level: level
                                };
                                for (let i = 0; i < this.state.regions.length; i++) {
                                    if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                        this.state.region_grid[level].children.push(this.state.regions[i])
                                    }
                                }
                                if (this.state.region_grid[level].children.length < 1) {
                                    delete this.state.region_grid[level];
                                }
                            }
                        } catch (e) {
                            this.state.region_grid[level] = {
                                value: "-1",
                                children: [],
                                title: "Select",
                                level: level
                            };
                            for (let i = 0; i < this.state.regions.length; i++) {
                                if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                    this.state.region_grid[level].children.push(this.state.regions[i])
                                }
                            }
                            if (this.state.region_grid[level].children.length < 1) {
                                delete this.state.region_grid[level];
                            }
                        }
                    } else {
                        this.state.region_grid[level] = {value: "-1", children: [], title: "Select", level: level};
                        for (let i = 0; i < this.state.regions.length; i++) {
                            if (this.state.regions[i].parent_id === target.id && this.state.regions[i].level > target.level) {
                                this.state.region_grid[level].children.push(this.state.regions[i])
                            }
                        }
                        if (this.state.region_grid[level].children.length < 1) {
                            delete this.state.region_grid[level];
                        }
                    }
                }

            } else {

                this.state.region_grid[level_key].error = false;
                this.state.region_grid[level_key].value = target;

                //RESET ALL LEVELS BELOW SELECTED TARGET
                for (let key in this.state.region_grid) {
                    if (+this.state.region_grid[key].level > +level_key) {
                        delete this.state.region_grid[key];
                    }
                }

            }

            let level_max = 4;
            if (salesChannelRegister.get('name') === 'boostabostad') {
                 level_max = 5;
            }


            this.setState({region_grid: this.state.region_grid}, () => {
                    if(this.state.value && level_key < level_max){
                        if(level_key < this.state.value.level){
                            this.functions.select(JSON.parse(this.state.region_grid[level_key].value));
                        }else if(level_key > this.state.value.level && level_key < level_max){
                            this.functions.select(JSON.parse(this.state.region_grid[level_key].value));
                        }else{
                            this.functions.select(JSON.parse(this.state.region_grid[level_key].value));
                        }
                    } else if (level_key < level_max) {
                        this.functions.select(JSON.parse(this.state.region_grid[level_key].value));
                    }
            });

        },
    };

    renders = {
        value: (value) => {
            try {
                return JSON.parse(value).name;
            } catch (e) {}
        },
        id: (value) => {
            try {
                return JSON.parse(value).id;
            } catch (e) {}
        }
    };

    render() {
        return (
            <div>
                {
                    Object.keys(this.state.region_grid).map((key, index) => {
                        if (this.state.region_grid[key].children.length > 0) {
                            return (
                                <div className={Styles.dropdownWrapper}>
                                    <div onClick={() => {
                                        this.functions.select(JSON.parse(this.state.region_grid[key].value), true);
                                    }} className={Styles.dropdownRadio}>
                                        {
                                            this.renders.id(this.state.region_grid[key].value) !== this.renders.id(JSON.stringify(this.state.value)) && this.renders.id(this.state.region_grid[key].value) &&
                                            <div className={Styles.dropdownRadioButton}/>
                                        }
                                        {
                                            this.renders.id(this.state.region_grid[key].value) === this.renders.id(JSON.stringify(this.state.value)) && this.renders.id(this.state.region_grid[key].value) &&
                                            <div className={Styles.dropdownRadioButtonSelected}>
                                                <div className={Styles.dropdownRadioButtonSelectedCenter}></div>
                                            </div>
                                        }
                                    </div>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={
                                        cx(Styles.dropdown, Styles.dropdownFlex,
                                            {
                                                [Styles.dropdownError]: (this.state.error || (this.state.errors && this.state.errors[key] && this.state.region_grid[key].value == '-1')) && window.location.hostname.indexOf("yieldlock") === -1,
                                                [Styles.dropdownErrorYieldlock]: (this.state.error || (this.state.errors && this.state.errors[key] && this.state.region_grid[key].value == '-1')) && window.location.hostname.indexOf("yieldlock") !== -1,
                                                //[Styles.dropdownError]: this.state.error && window.location.hostname.indexOf("yieldlock") === -1,
                                                //[Styles.dropdownErrorYieldlock]: this.state.error && window.location.hostname.indexOf("yieldlock") !== -1,
                                                [Styles.dropdownDisabled]: !this.state.inhouse && this.state.region_grid[key].level === 1,
                                                [Styles.dropdownFlexLast]: Object.keys(this.state.region_grid).length - 1 === index
                                            })
                                    }>
                                        <select
                                            value={this.state.region_grid[key].value}
                                            className={Styles.dropdownSelection}
                                            disabled={this.state.region_grid[key].level === 1 && !this.state.inhouse}
                                            onChange={(event) => this.functions.setRegion(event.target.value, key)}
                                        >
                                            <option value="-1" disabled>{this._renderText("item_1")}</option>
                                            {
                                                this.state.region_grid[key].children.sort(function (a, b) {
                                                    if (a.name < b.name) {
                                                        return -1;
                                                    }
                                                    if (a.name > b.name) {
                                                        return 1;
                                                    }
                                                    return 0;
                                                }).map((item) => {
                                                    return (
                                                        <option className={Styles.dropdownSelectionOption} value={JSON.stringify(item)}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        {
                                            this.renders.value(this.state.region_grid[key].value) && this.state.region_grid[key].level !== 1 &&
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>{this.renders.value(this.state.region_grid[key].value)}</div>
                                        }
                                        {
                                            this.renders.value(this.state.region_grid[key].value) && this.state.region_grid[key].level === 1 &&
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{}:{}} className={Styles.dropdownText}>{this.renders.value(this.state.region_grid[key].value)}</div>
                                        }
                                        {
                                            !this.renders.value(this.state.region_grid[key].value) && this.state.region_grid[key].value !== "-1" && this.state.region_grid[key].level !== 1 &&
                                            <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownText}>{this.state.region_grid[key].title}</div>
                                        }
                                        {
                                            this.state.region_grid[key].value === "-1" &&
                                            <div style={(salesChannelRegister.get('name')==='yieldlock' && !(this.state.error || (this.state.errors && this.state.errors[key] && this.state.region_grid[key].value == '-1')))?{color: '#00273A'}:{}} className={Styles.dropdownText}>{this._renderText("item_1")}</div>
                                        }
                                        {
                                            salesChannelRegister.get('name') !== "yieldlock" && !this.state.error && !this.state.disabled &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                        }
                                        
                                        {
                                            /*
                                           salesChannelRegister.get('name') !== "yieldlock" && this.state.disabled &&
                                           <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>
                                            */
                                        }
                                        {

                                           salesChannelRegister.get('name') !== "yieldlock" && !this.state.inhouse && this.state.region_grid[key].level === 1 &&
                                           <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>

                                        }
                                        {
                                            salesChannelRegister.get('name') === "yieldlock" && !this.state.error && !this.state.disabled &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-yl.svg")}/>
                                        }
                                        {
                                            ((this.state.error || (this.state.errors && this.state.errors[key] && this.state.region_grid[key].value == '-1')) && !this.state.disabled && window.location.hostname.indexOf("yieldlock") !== -1) &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-error-yl.svg")}/>
                                        }
                                        {
                                            ((this.state.error || (this.state.errors && this.state.errors[key] && this.state.region_grid[key].value == '-1')) && !this.state.disabled && window.location.hostname.indexOf("yieldlock") === -1) &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-error.svg")}/>
                                        }
                                        {
                                            /*
                                            salesChannelRegister.get('name') === "yieldlock" && this.state.disabled &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>
                                             */
                                        }
                                        {
                                            salesChannelRegister.get('name') === "yieldlock" && !this.state.inhouse && this.state.region_grid[key].level === 1 &&
                                            <img className={Styles.dropdownArrow} src={require("../../assets/images/arrow-down-disabled.svg")}/>
                                        }
                                    </div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        );
    }
}

export default DropdownRegionNarrow;


// WEBPACK FOOTER //
// ./src/components/dropdown-region-narrow/component.js